import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center, VStack, Select, Checkbox
} from '@chakra-ui/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdSettings, MdAdd, MdAddCircleOutline, MdDeleteForever, MdSave, MdBackHand } from 'react-icons/md';
import { FaRegCalendarAlt, FaRegClock, FaSpellCheck, FaStop, FaMoneyCheck } from 'react-icons/fa';

import { createForm } from 'final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { Form, Field } from 'react-final-form';
import { withNamespaces } from 'react-i18next';

import { 
    SUCCESS_STATUS, FAILED_STATUS, SIZE_LIST, 
    WORK_DAILY_SETTING, WORK_HOURLY_SETTING, PATIENT_RESULT_SETTING, FOOD_AVOID_SETTING, PAYMENT_SETTING, 
    WORK_DAILY_LIST, WORK_HOURLY_LIST, PATIENT_RESULT_TYPES, FOOD_AVOIDS, PAYMENT_SUPPLIERS
} from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiCreateNewSystemSetting, apiUpdateASystemSetting, apiLoadASystemSettingByCompanyId
} from '../../../redux/apis/SystemSettingApis';
import { clearSystemSettingActionStatus } from '../../../redux/actions';
import { getASystemSetting, getSystemSettingActionStatus, getSystemSettingActionMsg, getSystemSettingError } from '../../../redux/selectors';

import NoDataPage from '../../../components/NoData';
import { displayConfirmAlert } from '../../utils';
import i18n from '../../../i18n';

function Systems({
    systemSettingDetail, actionStatus, actionMsg, error, clearSystemSettingActionStatus, 
    apiLoadASystemSettingByCompanyId, apiCreateNewSystemSetting, apiUpdateASystemSetting, t
}) {
    const mounted = useRef();

    const [ cookies ] = useCookies(["loginCookie"]);
    const [ isAction, setIsAction ] = useState(false);
    const [ selectedBtn, setSelectedBtn] = useState(WORK_DAILY_SETTING);

    useEffect(() => {
        if(!mounted.current) {
            apiLoadASystemSettingByCompanyId({ company_id: cookies?.loginCookie?.data?.company_id });
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearSystemSettingActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearSystemSettingActionStatus();
            }
        }
    });

    const onSubmit = async(values) => {
        if(systemSettingDetail?.id) {
            apiUpdateASystemSetting({ 
                id: systemSettingDetail.id, 
                payload: {
                    ...values,
                    user_id: cookies?.loginCookie?.data?.id,
                }
            });
        } else {
            apiCreateNewSystemSetting({ 
                ...values,
                user_id: cookies?.loginCookie?.data?.id,   
            });
        }
    }

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} width="100vw" p={4}>
                <Flex flexDirection="column" maxW={{ base: "100%", md: "20vw", lg: "20vw" }} gap={0.5}>
                    <Button borderRadius={0} justifyContent="flex-start"
                        bg={selectedBtn === WORK_DAILY_SETTING ? "green.500" : "gray.100"}
                        color={selectedBtn === WORK_DAILY_SETTING ? "white" : "black"}
                        onClick={() => {
                                setSelectedBtn(WORK_DAILY_SETTING)
                            }
                        }
                    >
                        <Icon boxSize={6} as={FaRegCalendarAlt} marginRight="8px"/>   
                        <Text fontWeight="400">{t("Working_Daily")}</Text>
                    </Button>

                    <Button borderRadius={0} justifyContent="flex-start"
                        bg={selectedBtn === WORK_HOURLY_SETTING ? "green.500" : "gray.100"}
                        color={selectedBtn === WORK_HOURLY_SETTING ? "white" : "black"}
                        onClick={
                            () => {
                                setSelectedBtn(WORK_HOURLY_SETTING)
                            }
                        }
                    >
                        <Icon boxSize={6} as={FaRegClock} marginRight="8px"/>   
                        <Text fontWeight="400">{t("Working_Hourly")}</Text>
                    </Button>

                    <Button borderRadius={0} justifyContent="flex-start"
                        bg={selectedBtn === PATIENT_RESULT_SETTING ? "green.500" : "gray.100"}
                        color={selectedBtn === PATIENT_RESULT_SETTING ? "white" : "black"}
                        onClick={
                            () => {
                                setSelectedBtn(PATIENT_RESULT_SETTING)
                            }
                        }
                    >
                        <Icon boxSize={6} as={FaSpellCheck} marginRight="8px"/>   
                        <Text fontWeight="400">{t("Medical_Result")}</Text>
                    </Button>

                    <Button borderRadius={0} justifyContent="flex-start"
                        bg={selectedBtn === FOOD_AVOID_SETTING ? "green.500" : "gray.100"}
                        color={selectedBtn === FOOD_AVOID_SETTING ? "white" : "black"}
                        onClick={
                            () => {
                                setSelectedBtn(FOOD_AVOID_SETTING)
                            }
                        }
                    >
                        <Icon boxSize={6} as={MdBackHand} marginRight="8px"/>   
                        <Text fontWeight="400">{t("Food_Avoid")}</Text>
                    </Button>

                    <Button borderRadius={0} justifyContent="flex-start"
                        bg={selectedBtn === PAYMENT_SETTING ? "green.500" : "gray.100"}
                        color={selectedBtn === PAYMENT_SETTING ? "white" : "black"}
                        onClick={
                            () => {
                                setSelectedBtn(PAYMENT_SETTING)
                            }
                        }
                    >
                        <Icon boxSize={6} as={FaMoneyCheck} marginRight="8px"/>   
                        <Text fontWeight="400">{t("Online_Payment")}</Text>
                    </Button>


                </Flex>

                <Flex flexDirection="column" w="100%" mt={4} px={2}>
                    { 
                        selectedBtn === WORK_DAILY_SETTING && 
                        <WorkDailyForm 
                            isAction={isAction}
                            t={t}
                            company_id={cookies?.loginCookie?.data?.company_id} 
                            systemSettingDetail={systemSettingDetail}
                            onSubmit={onSubmit}
                        /> 
                    }
                    { 
                        selectedBtn === WORK_HOURLY_SETTING && 
                        <WorkTimeForm 
                            isAction={isAction}
                            t={t}
                            company_id={cookies?.loginCookie?.data?.company_id} 
                            systemSettingDetail={systemSettingDetail}
                            onSubmit={onSubmit}
                        /> 
                    }
                    { 
                        selectedBtn === PATIENT_RESULT_SETTING && 
                        <PatientResultForm 
                            isAction={isAction}
                            t={t}
                            company_id={cookies?.loginCookie?.data?.company_id} 
                            systemSettingDetail={systemSettingDetail}
                            onSubmit={onSubmit}
                        /> 
                    }
                    { 
                        selectedBtn === FOOD_AVOID_SETTING && 
                        <FoodAvoidForm 
                            isAction={isAction}
                            t={t}
                            company_id={cookies?.loginCookie?.data?.company_id} 
                            systemSettingDetail={systemSettingDetail}
                            onSubmit={onSubmit}
                        /> 
                    }
                    { 
                        selectedBtn === PAYMENT_SETTING && 
                        <PaymentForm 
                            isAction={isAction}
                            t={t}
                            company_id={cookies?.loginCookie?.data?.company_id} 
                            systemSettingDetail={systemSettingDetail}
                            onSubmit={onSubmit}
                            setSelectedBtn={setSelectedBtn}
                        /> 
                    }
                </Flex>
            </Flex>
            <ToastContainer />
        </React.Fragment>
    )
}

const WorkDailyForm = ({ isAction, company_id, systemSettingDetail, onSubmit, t }) => {
    return (
        <React.Fragment>
            <Heading size="md">{t("Clinic_Working_Daily")}</Heading>
            <Form 
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...systemSettingDetail,
                    daily_time_schedules: {
                        ...systemSettingDetail?.daily_time_schedules,
                        work_daily: systemSettingDetail?.daily_time_schedules?.work_daily || WORK_DAILY_LIST
                    }, 
                }}
                render={
                    ({
                        handleSubmit,
                        submitting,
                        form, 
                        pristine,
                        valid,
                        values
                    }) => {
                        return (
                                <form onSubmit={handleSubmit}>
                                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} justifyContent="flex-start" gap={8} mt={2}>
                                        {
                                            Object.keys(WORK_DAILY_LIST).map(key => (
                                                <Field key={key} name={`daily_time_schedules.work_daily.${key}`} type='checkbox'>
                                                    {({ input, meta }) => (
                                                        <Checkbox {...input} isChecked={ input.checked }
                                                        >
                                                            {key}
                                                        </Checkbox>
                                                    )}
                                                </Field>
                                            ))
                                        }
                                    </Flex>
                                                                            
                                    <Button colorScheme='green' type='submit' mt={4} isDisabled={!valid || pristine || !isAction}>
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">{t("Save")}</Text>
                                    </Button>
                                </form>
                            )
                        }
                    }
            />
        </React.Fragment>
    )
}

const WorkTimeForm = ({ isAction, company_id, systemSettingDetail, onSubmit, t }) => {
    return (
        <React.Fragment>
            <Heading size="md">{t("Clinic_Working_Hourly")}</Heading>
            <Form 
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...systemSettingDetail,
                    daily_time_schedules: {
                        ...systemSettingDetail?.daily_time_schedules,
                        work_hourly: systemSettingDetail?.daily_time_schedules?.work_hourly || WORK_HOURLY_LIST
                    }
                }}
                render={
                    ({
                        handleSubmit,
                        form: {
                            mutators: { push, pop, remove }
                        },
                        submitting,
                        form, 
                        pristine,
                        valid,
                        values
                    }) => {
                        return (
                                <form onSubmit={handleSubmit}>
                                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" justifyContent="flex-start" gap={8} mt={2}>
                                        {
                                            Object.keys(WORK_HOURLY_LIST).map(key => (
                                                <Field key={key} name={`daily_time_schedules.work_hourly.${key}`} type='checkbox'>
                                                    {({ input, meta }) => (
                                                        <Checkbox {...input} w="150px" isChecked={ input.checked }
                                                        >
                                                            {key}
                                                        </Checkbox>
                                                    )}
                                                </Field>
                                            ))
                                        }                            
                                    </Flex>

                                    <Button colorScheme='green' type='submit' mt={4} isDisabled={!valid || pristine || !isAction}>
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">{t("Save")}</Text>
                                    </Button>
                                </form>
                            )
                        }
                    }
            />
        </React.Fragment>
    )
}

const PatientResultForm = ({
    isAction, company_id, systemSettingDetail, onSubmit, t
}) => {
    const validate = (values) => {
        const errors = {};

        if(values["patient_result_types"] && values["patient_result_types"].length > 0) {
            let totalTypeIsNull = values["patient_result_types"].filter(item => item.type === null || item.type === undefined)?.length;
            if(totalTypeIsNull > 0) {
                errors.type = "Required";
            }
        }

        return errors;
    }

    return (
        <React.Fragment>
            <Form 
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...systemSettingDetail,
                    patient_result_types: systemSettingDetail?.patient_result_types || PATIENT_RESULT_TYPES
                }}
                mutators={{
                    ...arrayMutators
                }}
                validate={validate}
                render={
                    ({
                        handleSubmit,
                        form: {
                            mutators: { push, pop, remove }
                        },
                        submitting,
                        form, 
                        pristine,
                        valid,
                        values
                    }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Flex px={4} py={2} justify="flex-start" borderBottomWidth="2px" gap={2}>
                                    <Button colorScheme='orange' isDisabled={!isAction} onClick={() => push('patient_result_types', {type: null})}>
                                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px" />   
                                        <Text fontSize="14px" fontWeight="400">{t("Add")}</Text>
                                    </Button>

                                    <Button colorScheme='green' type='submit' isDisabled={!valid || pristine || !isAction}>
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">{t("Save")}</Text>
                                    </Button>
                                </Flex>

                                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" gap={2}>
                                    <FieldArray name="patient_result_types">
                                        {
                                            ({ fields }) => fields.map((name, index) => {
                                                return (
                                                    <HStack key={name} mr={4} mt={2}>
                                                        <Field name={`${name}.type`}>
                                                            {({ input, meta }) => (
                                                                <HStack>
                                                                    <FormLabel color="#0d47a1" fontWeight="700">{t("Type")}</FormLabel>
                                                                    <Input {...input} type='text' placeholder='' />
                                                                </HStack>
                                                            )}
                                                        </Field>
                                                        <Field name={`${name}.size`}>
                                                            {({ input, meta }) => (
                                                                <Select {...input} placeholder={t("Select_Size")} maxW="150px">
                                                                    {
                                                                        SIZE_LIST.map(item => (
                                                                            <React.Fragment key={item.code}>
                                                                                <option value={item.code}>{item.label}</option>
                                                                            </React.Fragment>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            )}
                                                        </Field>
                                                        <IconButton
                                                            variant="outline"
                                                            colorScheme='red'
                                                            title='Xoá'
                                                            icon={<MdDeleteForever />}
                                                            onClick={() => remove('patient_result_types', index)}
                                                        />
                                                    </HStack>
                                                )
                                            })
                                        }
                                    </FieldArray>
                                </Flex>

                                <Center>
                                    <FieldArray name="patient_result_types">
                                        {
                                            ({ fields }) => {
                                                return (
                                                    !fields.value && <NoDataPage text={`Hiện tại chưa có dữ liệu!`}/>
                                                )
                                            }
                                        }
                                    </FieldArray>
                                </Center>
                            </form>
                        )
                    }
                }
            />
        </React.Fragment>
    )
}

const FoodAvoidForm = ({
    isAction, company_id, systemSettingDetail, onSubmit, t
}) => {
    const validate = (values) => {
        const errors = {};

        if(values["food_avoids"] && values["food_avoids"].length > 0) {
            let totalValueIsNull = values["food_avoids"].filter(item => item.value === null || item.value === undefined)?.length;
            if(totalValueIsNull > 0) {
                errors.value = "Required";
            }
        }

        return errors;
    }

    return (
        <React.Fragment>
            <Form 
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...systemSettingDetail,
                    food_avoids: systemSettingDetail?.food_avoids || FOOD_AVOIDS
                }}
                mutators={{
                    ...arrayMutators
                }}
                validate={validate}
                render={
                    ({
                        handleSubmit,
                        form: {
                            mutators: { push, pop, remove }
                        },
                        submitting,
                        form, 
                        pristine,
                        valid,
                        values
                    }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Flex px={4} py={2} justify="flex-start" borderBottomWidth="2px" gap={2}>
                                    <Button colorScheme='orange' isDisabled={!isAction} onClick={() => push('food_avoids', {})}>
                                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px" />   
                                        <Text fontSize="14px" fontWeight="400">{t("Add")}</Text>
                                    </Button>

                                    <Button colorScheme='green' type='submit' isDisabled={!valid || pristine || !isAction}>
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">{t("Save")}</Text>
                                    </Button>
                                </Flex>

                                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" gap={2}>
                                    <FieldArray name="food_avoids">
                                        {
                                            ({ fields }) => fields.map((name, index) => {
                                                return (
                                                    <Flex key={name} mr={4} mt={2} align="flex-end" gap={2}>
                                                        <Field name={`${name}.value`}>
                                                            {({ input, meta }) => (
                                                                <FormControl>
                                                                    <FormLabel color="#0d47a1" fontWeight="700">{t("Food")}/{t("Substance")}</FormLabel>
                                                                    <Input {...input} type='text' placeholder='' />
                                                                </FormControl>
                                                            )}
                                                        </Field>
                                                        <IconButton
                                                            variant="outline"
                                                            colorScheme='red'
                                                            title='Xoá'
                                                            icon={<MdDeleteForever />}
                                                            onClick={() => remove('food_avoids', index)}
                                                        />
                                                    </Flex>
                                                )
                                            })
                                        }
                                    </FieldArray>
                                </Flex>

                                <Center>
                                    <FieldArray name="food_avoids">
                                        {
                                            ({ fields }) => {
                                                return (
                                                    !fields.value && <NoDataPage text={`Hiện tại chưa có dữ liệu!`}/>
                                                )
                                            }
                                        }
                                    </FieldArray>
                                </Center>
                            </form>
                        )
                    }
                }
            />
        </React.Fragment>
    )
}

const PaymentForm = ({ isAction, company_id, systemSettingDetail, onSubmit, setSelectedBtn, t }) => {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const mounted = useRef();

    useEffect(() => {
        if(!mounted.current) {
            if(cookies.loginCookie?.data?.companyDetail?.register_type === "FREE") {
                displayConfirmAlert("Bạn cần nâng cấp gói dịch vụ để sử dụng tính năng này!", () => {
                    setSelectedBtn(WORK_DAILY_SETTING);
                });
            }
            mounted.current = true;
        }
    });

    const validate = (values) => {
        const errors = {};

        if(!values?.payment_methods?.supplier) {
            errors.payment_methods = "Required";
        }
        if(!values?.payment_methods?.client_id) {
            errors.payment_methods = "Required";
        }
        if(!values?.payment_methods?.api_key) {
            errors.payment_methods = "Required";
        }
        if(!values?.payment_methods?.checksum_key) {
            errors.payment_methods = "Required";
        }

        return errors;
    }

    return (
        <React.Fragment>
            <Form 
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...systemSettingDetail,
                }}
                validate={validate}
                render={
                    ({
                        handleSubmit,
                        form: {
                            mutators: { push, pop, remove }
                        },
                        submitting,
                        form, 
                        pristine,
                        valid,
                        values
                    }) => {
                        return (
                                <form onSubmit={handleSubmit}>
                                    <Field name="payment_methods.isPaymentOnline" type='checkbox'>
                                        {({ input, meta }) => (
                                            <Checkbox {...input} isChecked={ input.checked }>
                                                {t("Allow_Payment_Online")}
                                            </Checkbox>
                                        )}
                                    </Field>

                                    <Field name="payment_methods.supplier">
                                        {({ input, meta }) => (
                                            <FormControl mt={4} maxW="300px" isRequired isDisabled={!values?.payment_methods?.isPaymentOnline}>
                                                <FormLabel>{t("Select_Payment_Supplier")}</FormLabel>
                                                <Select {...input} placeholder={t("Select_Supplier")}>
                                                    {
                                                        Object.keys(PAYMENT_SUPPLIERS).map(key => (
                                                            <React.Fragment key={key}>
                                                                <option value={key}>{key}</option>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Field>
                                    
                                    <Field name="payment_methods.client_id">
                                        {({ input, meta }) => (
                                            <FormControl maxW="500px" isRequired isDisabled={!values?.payment_methods?.isPaymentOnline}>
                                                <FormLabel>Client Id</FormLabel>
                                                <Input {...input} type='text' placeholder='Client Id' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="payment_methods.api_key">
                                        {({ input, meta }) => (
                                            <FormControl maxW="500px" isRequired isDisabled={!values?.payment_methods?.isPaymentOnline}>
                                                <FormLabel>Api Key</FormLabel>
                                                <Input {...input} type='text' placeholder='Api Key' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="payment_methods.checksum_key">
                                        {({ input, meta }) => (
                                            <FormControl maxW="500px" isRequired isDisabled={!values?.payment_methods?.isPaymentOnline}>
                                                <FormLabel>Checksum Key</FormLabel>
                                                <Input {...input} type='text' placeholder='Checksum Key' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Button colorScheme='green' type='submit' mt={4} isDisabled={!valid || pristine || !isAction}>
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">{t("Save")}</Text>
                                    </Button>
                                </form>
                            )
                        }
                    }
            />
            {
                i18n.language === "en" &&
                <Text mt={4} as="i" color="orange.600">
                    When need support to setup payment gate, please contact with
                    <a href={`https://moctrasoft.com`} style={{ color: "green"}} target='_blank'> MỘC TRÀ SOFT</a>
                </Text>
            }
            {
                 i18n.language === "vi" &&
                <Text mt={4} as="i" color="orange.600">
                    Khi cần hỗ trợ thiết lập cổng thanh toán, phòng khám liên hệ 
                    <a href={`https://moctrasoft.com`} style={{ color: "green"}} target='_blank'> MỘC TRÀ SOFT</a> để được hỗ trợ thêm
                </Text>
            }
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const systemSettingDetail       =   getASystemSetting(state);
    const actionStatus              =   getSystemSettingActionStatus(state);
    const actionMsg                 =   getSystemSettingActionMsg(state);
    const error                     =   getSystemSettingError(state);

    return { systemSettingDetail, actionStatus, actionMsg, error };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadASystemSettingByCompanyId:       payload => dispatch(apiLoadASystemSettingByCompanyId(payload)),
    apiCreateNewSystemSetting:              payload => dispatch(apiCreateNewSystemSetting(payload)),
    apiUpdateASystemSetting:                payload => dispatch(apiUpdateASystemSetting(payload)),

    clearSystemSettingActionStatus:         payload => dispatch(clearSystemSettingActionStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Systems));